<template>
  <div class="shiftManage">
    <el-row :gutter="10">
      <OACard header="选择公司" :col="6">
        <div v-if="!companyData.length" class="empty">暂无数据</div>
        <el-radio-group v-model="companyId" class="duty" @change="getCalendar">
          <div v-for="item in companyData" :key="item.id">
            <el-radio :label="item.id">{{item.companyName}}</el-radio>
          </div>
        </el-radio-group>
      </OACard>
      <OACard header="选择日期" :col="18">
        <el-row :gutter="24">
          <el-col :span="14">
            <el-select v-model="select" @change="getCalendar" size="medium">
              <el-option
                v-for="item in yearList"
                :key="item.code"
                :value="item.code"
                :label="item.name"
              ></el-option>
            </el-select>
          </el-col>
          <el-col :span="10" class="text-right">
            <el-button size="medium" type="primary" plain @click="setSingle">保存修改</el-button>
            <el-button size="medium" type="primary" plain @click="open">同步保存</el-button>
            <el-button size="medium" type="warning" plain @click="getCalendar">重置</el-button>
          </el-col>
        </el-row>

        <el-row :gutter="24">
          <el-col :span="8" v-for="(item,$index) in workdata" :key="$index">
            <OACalendar :workdata="item" v-if="calendarShow" @change="spanClick" :month="$index"></OACalendar>
          </el-col>
        </el-row>
        <el-row v-if="isEmpty" class="empty">暂无数据</el-row>
      </OACard>

      <el-dialog title="请选择需要同步的公司" :visible.sync="dialogVisible" width="30%">
        <el-select v-model="companyIds" size="medium" multiple class="block">
          <el-option
            v-for="item in companyData"
            :key="item.id"
            :value="item.id"
            :label="item.companyName"
          ></el-option>
        </el-select>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="setShift">确 定</el-button>
        </span>
      </el-dialog>
    </el-row>
  </div>
</template>
<script>
import OACard from "@/components/OACard/OACard";
import OACalendar from "@/components/OACalendar/OACalendar";
import { getTenYears, resFilter } from "@/common/util.js";
import commonApi from "@/services/common.js";
import shiftApi from "@/services/shift";

export default {
  name: "shiftManage",
  components: { OACard, OACalendar },
  data() {
    return {
      companyId: 0,
      companyIds: [],
      companyData: [],
      workdata: [],
      calendarShow: false,
      setShow: false,
      dateList: [],
      dialogVisible: false,
      select: new Date().getFullYear(),
      yearList: getTenYears(),
      isEmpty: true
    };
  },
  methods: {
    async getCompany() {
      let res = await commonApi.getCompany();
      this.companyData = res.data.data;
    },
    async getCalendar() {
      if (this.companyId) {
        this.calendarShow = false;
        let res = await shiftApi.getCalendar({
          year: this.select,
          companyId: this.companyId
        });
        if (res.data.data.length > 0) {
          let yearData = _.groupBy(res.data.data, "month");
          this.workdata = _.map(yearData, month => {
            let monthData = {};
            _.map(month, item => {
              monthData[item.totime.split(" ")[0]] = item.calendarType;
            });
            return monthData;
          });
          this.calendarShow = true;
        }
        this.isEmpty = _.isEmpty(this.workdata);
      } else {
        this.$message.warning("请先选择公司");
      }
    },
    spanClick(day) {
      if (day.isSelect) {
        this.dateList.push({
          totime: day.date + " 00:00:00",
          calendarType: day.isWork ? 0 : 1
        });
      } else {
        this.dateList = _.filter(
          this.dateList,
          item => item.totime != day.date + " 00:00:00"
        );
      }
    },
    open() {
      if (this.companyId && this.dateList.length) {
        this.companyIds = [];
        this.dialogVisible = true;
        this.companyIds.push(this.companyId);
      } else {
        this.$message.warning("请先选择公司和需要调班的日期");
      }
    },
    setSingle() {
      if (this.companyId && this.dateList.length) {
        this.companyIds = [];
        this.companyIds.push(this.companyId);
        this.setShift();
      } else {
        this.$message.warning("请先选择公司和需要调班的日期");
      }
    },
    async setShift() {
      let res = await shiftApi.setState({
        companyIds: this.companyIds,
        dataList: this.dateList
      });
      this.calendarShow = false;
      this.dateList = [];
      resFilter(res, this.getCalendar());
    }
  },
  mounted() {
    this.getCompany();
  }
};
</script>
<style lang="scss">
.shiftManage {
  .duty {
    width: 100%;
    div {
      border: 1px solid #99befa;
      background: #fafafa;
      padding: 10px 20px;
      margin: 10px 0;
      cursor: pointer;
      .el-radio {
        width: 100%;
        .el-radio__input {
          float: right;
        }
        .el-radio__label {
          overflow: hidden;
          text-overflow: ellipsis;
          display: block;
        }
      }
    }
  }
  .el-row {
    margin-bottom: 10px;
  }
  .block {
    width: 100%;
  }
}
</style>



// WEBPACK FOOTER //
// src/pages/personnel/shiftManage.vue